export default __webpack_public_path__ + "7ca83cc048ac3b86bcee52135e502a1a.png";